<app-card-slider>
    <div appSliderItem 
    infinite-scroll
    [infiniteScrollDistance]="0.5"
    [infiniteScrollThrottle]="50"
    [horizontal]="true"
    [infiniteScrollContainer]="selector"
    [fromRoot]="true"
    (scrolled)="onScroll()"
    class="mb-3" *ngFor="let news of newsScroll">
        <mat-card class="new-card">
            <img mat-card-image height="150px" [src]="news.image" [alt]="news.title">
            <mat-card-content class="card-content">
                <p class="newstext">{{news.autor | truncate: "50"}}</p>
                <h4>
                    {{news.description|truncate:"250"}}
                </h4>
            </mat-card-content>
            <mat-card-actions align="middle">
                <button routerLink="/noticia/{{news.id}}" mat-stroked-button color="warn">
                    VER MAS
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</app-card-slider>
